import { Grid2 } from '@mui/material';
import SideNav from '../Komponenten/Sidenav';
import Header from '../Komponenten/Header';
import { Hashtag } from '../Komponenten/Hashtag';
import MitgliedAntrag from '../DJKMitgliederAntrag.pdf';
import MitgliedAntragOhneWechsel from '../DJKMitgliederAntragOhneWechsel.pdf';
import './MitgliedWerden.css';

export default function MitgliedWerden() {
    return (
        <>
            <SideNav />
            <Grid2 container padding={5} spacing={4}>
                <Grid2 size={12} display="flex" justifyContent="center" alignItems="center" >
                    <Header />
                </Grid2>
                <Grid2 size={12} display="flex" justifyContent="center" alignItems="center">
                    <div className="mitglied-text">
                        <strong><Hashtag text="#DJK.Mitglied.Werden" /></strong>
                        <br/><br/>
                        Vielen Dank, dass Sie sich dafür interessieren in unserem Verein Mitglied zu werden. Hier finden Sie alle dafür notwendigen Formulare und Informationen. Bei Fragen rund um den Mitgliedsantrag wenden Sie sich bitte an: <a href="mailto:verwaltung@djkdurlach.de">verwaltung@djkdurlach.de</a>
                        <br/><br/>
                        <strong>Hier geht's zu den Antrags-Formularen:</strong>
                        <ul>
                            <li><a href={MitgliedAntragOhneWechsel} target="_blank" rel="noreferrer">Mitglieds-Antrag Fußball (ohne Spieler Pass)</a></li>
                            <li><a href={MitgliedAntrag} target="_blank" rel="noreferrer">Mitglieds-Antrag Fußball (inkl. erstmaliger Antrag auf Spieler-Pass / ab E Junioren)</a></li>
                            <li><a href={MitgliedAntrag} target="_blank" rel="noreferrer">Mitglieds-Antrag Fußball (inkl. Vereinswechsel von einem anderen Verein, Spieler-Pass besteht bereits)</a></li>
                            <li><a href={MitgliedAntragOhneWechsel} target="_blank" rel="noreferrer">Mitglieds-Antrag andere Abteilungen (Tennis, Freizeit, usw.)</a></li>
                        </ul>
                        <strong><Hashtag text="#Jetzt.Mitglied.Werden" />!</strong>
                    </div>
                </Grid2>
            </Grid2>
        </>
    );
}

//<br/>
  
//<strong>Allgemeine Informationen:</strong>
  //                      <ul>
    //                        <li><a href="#" target="_blank" rel="noreferrer">Beitrags-Ordnung</a></li>
      //                      <li><a href="#" target="_blank" rel="noreferrer">Verhaltens-Kodex</a></li>
        //                </ul>
          //              <br/>